import { render, staticRenderFns } from "./MessagingPage.vue?vue&type=template&id=9c278770&scoped=true&lang=pug"
import script from "./MessagingPage.vue?vue&type=script&lang=js"
export * from "./MessagingPage.vue?vue&type=script&lang=js"
import style0 from "./MessagingPage.vue?vue&type=style&index=0&id=9c278770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c278770",
  null
  
)

export default component.exports